import { render, staticRenderFns } from "./Bpaciente.vue?vue&type=template&id=49551a04"
import script from "./Bpaciente.vue?vue&type=script&lang=js"
export * from "./Bpaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports